import { classes as classSeed } from '../../../data/modules';
import { Magazine, MagazineLesson, ReusableClass, Segment } from '../types/trimestersSettings.types';

export const segmentsMock: Segment[] = [
  { id: 'segment-bercario', name: 'Bercario', ageStart: 0, ageEnd: 3 },
  { id: 'segment-primarios', name: 'Primarios', ageStart: 7, ageEnd: 10 },
  { id: 'segment-adolescentes', name: 'Adolescentes', ageStart: 11, ageEnd: 14 },
  { id: 'segment-adultos', name: 'Adultos', ageStart: 26, ageEnd: 59 },
  { id: 'segment-obreiros', name: 'Obreiros', ageStart: 18, ageEnd: 99 },
];

const lessonTitles = [
  'A chamada para servir',
  'Fundamentos da fe',
  'Vida devocional',
  'Comunhao e discipulado',
  'Familia e testemunho',
  'Mordomia crista',
  'Evangelizacao diaria',
  'Dons a servico da igreja',
  'Santidade pratica',
  'Cuidado com o proximo',
  'Perseveranca na jornada',
  'Esperanca e missao',
  'Revisao do trimestre',
];

export const buildMagazineLessons = (prefix: string): MagazineLesson[] =>
  Array.from({ length: 13 }, (_, index) => ({
    id: `${prefix}-lesson-${index + 1}`,
    number: index + 1,
    title: lessonTitles[index],
    summary: `Resumo mockado da lição ${index + 1} para orientar a aula e a futura integração.`,
  }));

export const magazinesMock: Magazine[] = [
  {
    id: 'mag-adultos-2026-1',
    title: 'Adultos - A Igreja e sua missão',
    trimesterId: 't1-2026',
    segmentId: 'segment-adultos',
    description: 'Revista trimestral para classes adultas da EBD.',
    lessons: buildMagazineLessons('mag-adultos-2026-1'),
  },
  {
    id: 'mag-adolescentes-2026-1',
    title: 'Adolescentes - Identidade crista',
    trimesterId: 't1-2026',
    segmentId: 'segment-adolescentes',
    description: 'Conteudo voltado para adolescentes, com linguagem direta e aplicacao pratica.',
    lessons: buildMagazineLessons('mag-adolescentes-2026-1'),
  },
  {
    id: 'mag-primarios-2026-1',
    title: 'Primarios - Conhecendo Jesus',
    trimesterId: 't1-2026',
    segmentId: 'segment-primarios',
    description: 'Revista infantil com 13 licoes para acompanhamento semanal.',
    lessons: buildMagazineLessons('mag-primarios-2026-1'),
  },
];

const segmentByCategory = (category: string) => {
  const normalized = category.toLowerCase();

  if (normalized.includes('prim')) return 'segment-primarios';
  if (normalized.includes('adolesc')) return 'segment-adolescentes';
  if (normalized.includes('obreiro')) return 'segment-obreiros';
  if (normalized.includes('adult')) return 'segment-adultos';
  return 'segment-bercario';
};

export const buildReusableClassesMock = (): ReusableClass[] =>
  classSeed.map((classItem) => {
    const segmentId = segmentByCategory(classItem.category);
    const magazine = magazinesMock.find((item) => item.segmentId === segmentId);

    return {
      id: classItem.id,
      title: classItem.title,
      teachers: classItem.teachers,
      students: classItem.students,
      segmentId,
      magazineId: magazine?.id ?? '',
      includeClass: true,
      includeTeachers: true,
      includeStudents: true,
    };
  });
